import { render } from "./index.vue?vue&type=template&id=a4002a3e&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=a4002a3e&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=a4002a3e&lang=scss"

import exportComponent from "/spug/spug_api/repos/119_10566_20260928180206/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4002a3e"],['__file',"src/app/program/views/license/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a4002a3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a4002a3e', __exports__)) {
    console.log('reload')
    api.reload('a4002a3e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=a4002a3e&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('a4002a3e', render)
  })

}


export default __exports__